import { render, staticRenderFns } from "./MyTariffWidget.vue?vue&type=template&id=59d0bd8c&scoped=true"
import script from "./MyTariffWidget.vue?vue&type=script&lang=js"
export * from "./MyTariffWidget.vue?vue&type=script&lang=js"
import style0 from "./MyTariffWidget.vue?vue&type=style&index=0&id=59d0bd8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d0bd8c",
  null
  
)

export default component.exports